var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14991_58352)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    rx: 43,
    fill: "#2C495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2019 67.3397L17.3716 74.3381C16.6187 74.7487 15.9421 75.2533 15.3125 75.8034C22.7929 82.1106 32.4492 85.9157 42.9996 85.9157C53.4722 85.9157 63.0668 82.1674 70.5261 75.9462C69.8381 75.3653 69.0917 74.8428 68.2642 74.4306L54.5253 67.562C52.7501 66.6744 51.6288 64.8603 51.6288 62.8758V57.4854C52.015 57.0456 52.4564 56.481 52.9286 55.8141C54.8011 53.1692 56.2177 50.2598 57.1994 47.2076C58.9616 46.664 60.2597 45.0365 60.2597 43.1023V37.3484C60.2597 36.0827 59.6966 34.9518 58.822 34.1599V25.8422C58.822 25.8422 60.5306 12.8984 43.0013 12.8984C25.4719 12.8984 27.1805 25.8422 27.1805 25.8422V34.1599C26.3043 34.9518 25.7428 36.0827 25.7428 37.3484V43.1023C25.7428 44.6178 26.5396 45.9516 27.7322 46.7224C29.1699 52.9809 32.9344 57.4854 32.9344 57.4854V62.7427C32.9328 64.6575 31.8845 66.4213 30.2019 67.3397Z",
    fill: "#E7ECED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14991_58352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    rx: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.1221164cb663a0e8beba8783aa99e70b.svg";
export { ForwardRef as ReactComponent };